// extracted by mini-css-extract-plugin
export default {"playerContainer":"MusicPlayer_playerContainer__ZZ6gy","playerImage":"MusicPlayer_playerImage__KjwHR"};